import _ from "lodash";
import React from "react";
import { useLocation } from "react-router-dom";

import { MultipleNavigationChain } from "../../router/WizardRouter";
import { WizardStep } from "./wizardStep/WizardStep";
import { useIntlTranslate } from "../../hooks";

import "./WizardSteps.scss";

const initialSteps = [
  {
    stepNumber: 1,
    title: "create_profiles",
    titleMobile: "create_profiles_mobile",
    ariaLabel: "aria_profile_creation",
  },
  {
    stepNumber: 2,
    title: "protection_setup",
    titleMobile: "protection_setup_mobile",
    ariaLabel: "aria_protection_setup",
  },
  {
    stepNumber: 3,
    title: "assign_devices",
    titleMobile: "assign_devices_mobile",
    ariaLabel: "aria_assigning_devices",
  },
];

const calculateSteps = (currentStep) =>
  initialSteps.map((step) => ({
    ...step,
    isActive: step.stepNumber === currentStep,
    isCompleted: step.stepNumber <= currentStep - 1,
  }));

const getStepIndex = (step) => _.indexOf(MultipleNavigationChain, step) + 1;

export const WizardSteps = () => {
  const location = useLocation();
  const translate = useIntlTranslate();
  const steps = calculateSteps(getStepIndex(location.pathname));
  const activeStep = _.find(steps, { isActive: true }).stepNumber;

  return (
    <ul
      className="wizard-steps"
      aria-label={translate("aria_wizard_steps_list", {
        activeStep: translate(`aria_stepNumber_${activeStep}`),
      })}
      aria-live="polite"
    >
      {steps &&
        steps.map(
          ({
            title,
            titleMobile,
            stepNumber,
            isActive,
            isCompleted,
            ariaLabel,
          }) => (
            <WizardStep
              key={title}
              title={title}
              titleMobile={titleMobile}
              stepNumber={stepNumber}
              isActive={isActive}
              isCompleted={isCompleted}
              ariaLabel={ariaLabel}
            />
          )
        )}
    </ul>
  );
};
